// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import apiClient from "../config/api";
import { handleApiCall } from "../utils/apiHelper";

export const userService = {
  /**
   * Test function to check API connectivity
   */
  /**
   * Get all tenant users
   */
  getTenantUsers: async () => {
    return handleApiCall(
      () => apiClient.get(`/admin/users/`),
      "Error fetching tenant users",
    );
  },

  /**
   * Create a new tenant user
   */
  postTenantUser: async (userData) => {
    return handleApiCall(
      () => apiClient.post(`/admin/users/`, userData),
      "Error posting tenant user",
    );
  },

  /**
   * Update a tenant user
   */
  putTenantUser: async (userId, userData) => {
    return handleApiCall(
      () => apiClient.put(`/admin/users/${userId}`, userData),
      "Error putting tenant user",
    );
  },

  /**
   * Delete a tenant user
   */
  deleteTenantUser: async (user_id) => {
    return handleApiCall(
      () => apiClient.delete(`/admin/users/${user_id}`),
      "Error deleting tenant user",
    );
  },

  /**
   * Fetch the user's profile picture as a Blob. Returns null when the user
   * has no picture so callers can fall back to an avatar placeholder.
   */
  getUserPicture: async (userId) => {
    try {
      const response = await apiClient.get(`/users/${userId}/picture`, {
        responseType: "blob",
        headers: { Accept: "image/*" },
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) return null;
      console.error("Error fetching user picture:", error);
      return null;
    }
  },
};
